import { render, staticRenderFns } from "./DeviceTable.vue?vue&type=template&id=7b197cb6&scoped=true"
import script from "./DeviceTable.vue?vue&type=script&lang=ts"
export * from "./DeviceTable.vue?vue&type=script&lang=ts"
import style0 from "./DeviceTable.vue?vue&type=style&index=0&id=7b197cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b197cb6",
  null
  
)

export default component.exports